import { QUEST_REWARD_TYPE } from "../quests/quest.enums";
import { z } from "zod";

export const SpinningWheelRewardSchema = z.object({
  id: z.uuid(),
  rewardCount: z.number().positive(),
  rewardType: z.nativeEnum(QUEST_REWARD_TYPE),
});
export type SpinningWheelReward = z.infer<typeof SpinningWheelRewardSchema>;
